import AGREGAR_CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICA from '@/graphql/mutations/administracion/catalogos/infraestructurasubtiposcaracteristicas/agregarCatalogoInfraestructuraSubtipoCaracteristica.gql';
import ACTUALIZAR_CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICA from '@/graphql/mutations/administracion/catalogos/infraestructurasubtiposcaracteristicas/actualizarCatalogoInfraestructuraSubtipoCaracteristica.gql';
import REMOVER_CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICA from '@/graphql/mutations/administracion/catalogos/infraestructurasubtiposcaracteristicas/removerCatalogoInfraestructuraSubtipoCaracteristica.gql';
import CATALOGO_INFRAESTRUCTURA_SUBTIPOS from '@/graphql/querys/administracion/catalogos/infraestructurasubtipos/catalogoInfraestructuraSubtipos.gql';
import CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICAS from '@/graphql/querys/administracion/catalogos/infraestructurasubtipocaracteristicas/catalogoInfraestructuraSubtipoCaracteristicas.gql';

export default {
  apollo: {
    catalogoInfraestructuraSubtipos: {
      query: CATALOGO_INFRAESTRUCTURA_SUBTIPOS,
    },
  },
  methods: {
    // Agregar Caracteristica Subtipo Infraestructura
    async mixAgregarCaracteristicaSubtipoInfraestructura() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICA,
          variables: {
            subtipoInfraestructuraCaracteristicas: this.subtipoInfraestructuraCaracteristicas,
          },
          update: (store, { data: { agregarCatalogoInfraestructuraSubtipoCaracteristica } }) => {
            const query = {
              query: CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICAS,
              variables() {
                return {
                  idSubtipoInfraestructura: this.subtipoInfraestructuraCaracteristicas
                    .idSubtipoInfraestructura,
                };
              },
            };
            const { catalogoInfraestructuraSubtipoCaracteristicas } = store.readQuery(query);
            const catInfraSubtipoCaracteristicasCopy = catalogoInfraestructuraSubtipoCaracteristicas
              .slice();
            catInfraSubtipoCaracteristicasCopy
              .push(agregarCatalogoInfraestructuraSubtipoCaracteristica);
            store.writeQuery({
              ...query,
              data: {
                catalogoInfraestructuraSubtipoCaracteristicas:
                catInfraSubtipoCaracteristicasCopy,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Editar Caracteristica Subtipo Infraesatructura
    async mixActualizarCaracteristicaSubtipoInfraestructura() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICA,
          variables: {
            id: this.subtipoInfraestructuraCaractetristicaEditar.id,
            subtipoInfraestructuraCaracteristicas: this.subtipoInfraestructuraCaracteristicas,
          },
          update: (store, { data: { actualizarCatalogoInfraestructuraSubtipoCaracteristica } }) => {
            const query = {
              query: CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICAS,
              variables() {
                return {
                  idSubtipoInfraestructura: this.subtipoInfraestructuraCaracteristicas
                    .idSubtipoInfraestructura,
                };
              },
            };
            const data = store.readQuery(query);
            const { catalogoInfraestructuraSubtipoCaracteristicas } = data;
            const index = catalogoInfraestructuraSubtipoCaracteristicas
              .findIndex((catInfraestSubtipoCaracteristica) => catInfraestSubtipoCaracteristica.id
              === actualizarCatalogoInfraestructuraSubtipoCaracteristica.id);
            if (index !== -1) {
              catalogoInfraestructuraSubtipoCaracteristicas
                .splice(index, 1, actualizarCatalogoInfraestructuraSubtipoCaracteristica);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Subtipo Infraestructura
    async mixEliminarCaracteristicaSubtipoInfraestructura() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICA,
        variables: {
          id: this.caracteristicaSubtipoInfraestructuraEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CATALOGO_INFRAESTRUCTURA_SUBTIPO_CARACTERISTICAS,
            variables() {
              return {
                idSubtipoInfraestructura: this.caracteristicaSubtipoInfraestructuraEliminar
                  .idSubtipoInfraestructura,
              };
            },
          };
          const data = store.readQuery(query);
          const { catalogoInfraestructuraSubtipoCaracteristicas } = data;
          const index = catalogoInfraestructuraSubtipoCaracteristicas
            .findIndex((catInfraestrSubtipoCaracteristica) => catInfraestrSubtipoCaracteristica.id
            === this.caracteristicaSubtipoInfraestructuraEliminar.id);
          console.log(index);
          if (index !== -1) {
            catalogoInfraestructuraSubtipoCaracteristicas.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
  computed: {
    getSubtiposInfraestructura() {
      if (!this.catalogoInfraestructuraSubtipos) return [];
      return this.catalogoInfraestructuraSubtipos;
    },
  },
};
